import React from 'react';

function FilterButton({ text, filterProjects }) {
    return (
        <>
            <button
                onClick={(e) => filterProjects(e.target.textContent)}
                type="button"
                className="project-tab text-sm md:text-md"
            >
                {text}
            </button>
        </>
    );
}

export default FilterButton;
